import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
	type ExecuteImportRequest,
	postApiCodelistManagementImport,
} from "Infrastructure/Api/Api";
import { useSnackbar } from "Infrastructure/Providers/SnackbarProvider/SnackbarProvider";
import { IMPORT_JOBS_QUERY_KEY } from "../Queries/useImportJobsQuery";

export function useExecuteImportMutation() {
	const queryClient = useQueryClient();
	const showSnackbar = useSnackbar();

	return useMutation({
		mutationFn: (request: ExecuteImportRequest) =>
			postApiCodelistManagementImport(request),
		onSuccess: (response) => {
			if (response.status === 200) {
				if (response.data.success) {
					showSnackbar(
						`Import dokončen (${response.data.definitionsProcessed} definic zpracováno)`,
						"success",
					);
				} else {
					showSnackbar(
						response.data.errors?.length > 0
							? `Import selhal: ${response.data.errors[0]}`
							: "Import selhal",
						"error",
					);
				}
				queryClient.invalidateQueries({
					queryKey: [IMPORT_JOBS_QUERY_KEY],
				});
			} else if (response.status === 400) {
				showSnackbar("Neplatný požadavek", "error");
			} else {
				showSnackbar("Chyba při spuštění importu", "error");
			}
		},
		onError: () => {
			showSnackbar("Chyba při spuštění importu", "error");
		},
	});
}
